import { keepCharSet } from "seneca-common/utils/functions";

import { Score } from "../types";

export const INITIAL_SCORE: Score = {
  score: 0,
  select: {
    score: 0
  },
  multipleChoice: {
    score: 0
  }
};

const specialCharsSet = `$£%<>/`;
const punctuationCharSet = `.,!?:`;
const wordChars = `[${specialCharsSet}${punctuationCharSet}${keepCharSet}]`;
const sepChars = new RegExp(/[.-]/); // seperator chars that can appear in the middle of a word

export const newLine = `<br>`;
export const SELECTABLE_WORD_REGEX = new RegExp(
  `${newLine}|${wordChars}+${sepChars.source}?${wordChars}+|${wordChars}`,
  "gi"
);
